import { render, staticRenderFns } from "./WorkflowTemplateForm.vue?vue&type=template&id=0b7e3150&scoped=true"
import script from "./WorkflowTemplateForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./WorkflowTemplateForm.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./WorkflowTemplateForm.vue?vue&type=style&index=0&id=0b7e3150&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7e3150",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7e3150')) {
      api.createRecord('0b7e3150', component.options)
    } else {
      api.reload('0b7e3150', component.options)
    }
    module.hot.accept("./WorkflowTemplateForm.vue?vue&type=template&id=0b7e3150&scoped=true", function () {
      api.rerender('0b7e3150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Pages/WorkflowTemplates/Components/WorkflowTemplateForm.vue"
export default component.exports